module.exports = __webpack_public_path__ + "img/card_ip_stipulation5.aed6cf1e.svg";